import React from 'react';

const ChannelsScreen = () => <div className="ChannelsScreen" />;

export default ChannelsScreen;
